import styles from "./index.module.scss";
import React, { useState, useEffect } from 'react';
import {RecommendIcon} from "@/config/config";
import gaTracker from "@/ga";
import Image from "next/image";
import useLanguage from "@/hooks/useLanguage";
import AppImage from "@/components/AppImage";


const SortBy = ({current, onChange, freeSample, onChangeFreeSample}) => {
  // 点击后动态改变排序状态
  const isSomeConditionTrue = true;
  const {t} = useLanguage();
  const [sortByData, setSortByData] = useState([
    {
      name: t('sort.total_sold'),
      sort: -1,
      type: 1,
    },
    {
      name: t('sort.sold'),
      subName: t('sort.yesterday'),
      sort: -1,
      type: 3
    },
    {
      name: t('sort.earn_per_sale'),
      sort: -1,
      type: 6
    },
    {
      name: t('sort.commission_rate'),
      sort: -1,
      type: 4
    },
    {
      name: t('sort.gmv'),
      sort: -1,
      type: 2
    },
    {
      name: t('sort.rating'),
      sort: -1,
      type: 7
    }
  ]);
  const [currentSort, setCurrentSort] = useState(5);
  const [currentSortType, setCurrentSorType] = useState(-1);

  const onChangeSwitch = (type, index) => {
     setSortByData((prevData) => {
       // 设置所有项的sort值都为-1
       prevData.forEach((item, subIndex) => {
         if (index !== subIndex) {
            item.sort = -1;
         }
       });
      const newData = [...prevData];
       const item = newData[index];
       // 如果是-1 则赋值为 1
       if (item.sort === -1) {
         item.sort = 2;
       } else {
         type = 5;
         item.sort = -1;
       }
       setCurrentSort(type);
       setCurrentSorType(item.sort);

      return newData;
    });
  };

  useEffect(() => {
    onChange(currentSort, currentSortType, true);
  }, [currentSort, currentSortType]);

  return (
    <div className={styles.container}>
      <div className={styles.container}>
        {sortByData.map((item, index) => (
          <div
            key={index}
            onClick={() => onChangeSwitch(item.type, index)}
            className={`${styles.sortItem} ${item.sort === 1 && styles.active} ${current === item.type && styles.sort_item_active} shrink-0` }
              >
                <div className={styles.itemText}>{item.name}
                  { item.subName && <span className={styles.subName}>({item.subName})</span> }
                </div>
                <Image src={"/images/home-sort-down-icon.svg"} alt={""} width={10} height={10} className={"w-[6px] h-[12px] ml-1"}></Image>
                {/* <div className={styles.arrows}>*/}
                {/*  <div className={`${item.sort === 1 && current === item.type ? styles.activeUp : styles.arrowUp}`}></div>*/}
                {/*  <div className={`${item.sort === 2 && current === item.type ? styles.activeDown : styles.arrowDown}`}></div>*/}
                {/* </div>*/}
              </div>
            ))}
      </div>

      <div onClick={()=>{
        gaTracker.trackEvent("home_free_sample");
        onChangeFreeSample(!freeSample);
      }} className={"flex items-center shrink-0 cursor-pointer"}>
        <Image src={ freeSample ? "/images/home-checked.svg" : "/images/home-selected-icon.svg"} alt={""} width={16} height={16} className={"w-4 h-4 mr-1"}></Image>
        <div className={"text-[#4E4E4E] text-sm"}>{t('sort.free_sample_only')}</div>
      </div>


      <div onClick={()=>onChange(5, -1)}  className={"recommand_linear_bg flex shrink-0 px-2 items-center gap-1 text-white text-sm h-[30px] cursor-pointer hover:opacity-80 trans-all"}>
        <AppImage  className={"!w-5 !h-5"} src={"/images/like-icon.png"}></AppImage>
        {t("empty_h5.recommended")}
      </div>

      {/* <div onClick={()=>onChange(5, -1)} className={`${styles.recommend_btn} shrink-0`}>*/}
      {/*  <img src={RecommendIcon}/>*/}
      {/*  Recommended For You*/}
      {/* </div>*/}
    </div>
  );
};

export default SortBy;
